import Vue from 'vue';

Vue.directive('check-invalid-inputs', {
    bind: function(el, binding, vnode) {
        el.addEventListener('submit', function() {
            let errors = vnode.context.$validator.errors;
            
            if(errors && errors.items.length) {
                let minOffsetTop = Infinity;
                
                for(var i = 0; i < errors.items.length; i++) {
                    var fieldName = errors.items[i].field;
                    var scope = binding.expression;
            
                    var errorInput = document.querySelector(`[name=${fieldName}][data-vv-scope=${scope}]`);
                    
                    if(errorInput) {
                        const offsetTop = errorInput.offsetTop
            
                        if(offsetTop < minOffsetTop) {
                            minOffsetTop = offsetTop;
                        }
                    }
                }
                window.scrollTo({
                    top: minOffsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        })
    }
});

export default {}
